import { ApiService, ApiServiceInterface } from "../../../../../core";
import { AdsPlanDataResponse } from "../../../site/interfaces";
import { AdsSubscriptionPageController } from "../../core/controllers";

export class AdsSubscriptionPageControllerImpl implements AdsSubscriptionPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<AdsPlanDataResponse> {
        try {
            const response = await this.api.get('/ads-page');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }
}